import React, { Component } from "react";
import PropTypes from "proptypes";
import {
  FormBuilder,
  FieldGroup,
  FieldControl,
  Validators
} from "react-reactive-form";

export default class Admin extends Component {

  state = {
    loading: false
  }

  emulateUserForm = FormBuilder.group({
    emailAddress: ["", [Validators.required, Validators.email]]
  });

  emulateUser = (e, attrs) => {
    e.preventDefault();
    this.setState({
      loading: true
    });
    this.props.setParentState('emulate', attrs['emailAddress']);
    this.props.handleRouting();
  }

  render() {
    return this.state.loading ? (
      <div className="loader throbber" />
    ) : (
      <div className="row center justify-content-center">
        <div className="col-md-6 col-sm-12">
          <h2>Hola, Admin!</h2>
          <h4>Preview a Volunteer's Experience</h4>
          <FieldGroup
            control={this.emulateUserForm}
            render={({ submitted, value }) => (
              <form
                name="Admin Emulate User"
                id="emulate-user-form"
                onSubmit={e => this.emulateUser(e, value)}
                autoComplete="off"
              >
                <FieldControl
                  name="emailAddress"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <input
                        name="emailAddress"
                        className="form-control"
                        type="text"
                        {...handler()}
                      />
                      <label
                        htmlFor="emailAddress"
                        className={`label ${pristine ? "" : "notEmpty"}`}
                      >
                        Email Address
                        <span className="error">
                          {(touched || submitted) &&
                            hasError("required") &&
                            " - Required"}
                          {(touched || submitted) &&
                            hasError("email") &&
                            " - Not a valid Email"}
                        </span>
                      </label>
                    </div>
                  )}
                />
                <button type="submit" disabled={!this.emulateUserForm.valid}>
                  Submit
                </button>
              </form>
            )} />
        </div>
      </div>
    );
  }
}

Admin.propTypes = {
  setParentState: PropTypes.func.isRequired,
  handleRouting: PropTypes.func.isRequired
}
